import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchModule = async (id) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=searchModDropDown&companyid=${user.companyid}&prodid=${id}`,
  );

  return response.data;
};

const useModuleQuery = (id, options) => {
  return useQuery({
    queryKey: ["module", id],
    queryFn: () => fetchModule(id),
    enabled: options.enabled && !!id,
    retry: true,
    // cacheTime: 90000,
    // refetchInterval: false,
    // refetchIntervalInBackground: false,
    // staleTime: Infinity,
  });
};

export default useModuleQuery;
